import React, { useState } from 'react';
import Button from 'react-bootstrap/Button';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Card from 'react-bootstrap/Card';
import Modal from 'react-bootstrap/Modal';
import { loadStripe } from '@stripe/stripe-js';
import ShoppingCart from './utils/ShoppingCart';

// Make sure to call `loadStripe` outside of a component’s render to avoid
// recreating the `Stripe` object on every render.
const stripePromise = loadStripe(process.env.REACT_APP_STRIPE_PK);

const shippingPriceId = process.env.REACT_APP_STRIPE_PRICE_ID_USPS_SHIPPING_US;

function Cart() {
  const handleCheckoutClick = async (event) => {
    window.mixpanel.track('button', { name: 'checkout', action: 'click' });

    const freeShippingCutoff = 100.0;
    const items = [];

    const sc01 = new ShoppingCart();
    const cart01 = sc01.getDict();
    Object.keys(cart01).forEach((priceId) => {
      items.push({ price: priceId, quantity: cart01[priceId].quantity });
    });
    if (sc01.totalPrice() < freeShippingCutoff && sc01.totalPrice() > 50.0) {
      items.push({ price: shippingPriceId, quantity: 1 });
    }

    // When the customer clicks on the button, redirect them to Checkout.
    const stripe = await stripePromise;
    //const { error } =
    await stripe.redirectToCheckout({
      lineItems: items,
      mode: 'payment',
      successUrl: 'https://www.hadabot.com/order_confirmation.html',
      cancelUrl: 'https://www.hadabot.com/cart.html',
      shippingAddressCollection: {
        allowedCountries: ['US'],
      },
    });
    // If `redirectToCheckout` fails due to a browser or network
    // error, display the localized error message to your customer
    // using `error.message`.
  };

  const [
    showInternationalCheckoutModal,
    setShowInternationalCheckoutModal,
  ] = useState(false);

  const sc = new ShoppingCart();
  const [cart, setCart] = useState(sc.getDict());

  function removeItem(priceId) {
    const sc01 = new ShoppingCart();
    sc01.setItem(priceId, 0, 0, '');
    sc01.saveCart();
    setCart(sc01.getDict());
  }

  function onQuantityChange(evt, priceId) {
    const newVal = parseInt(evt.target.value, 10);
    if (newVal !== undefined && newVal >= 1) {
      const sc01 = new ShoppingCart();
      sc01.setItem(
        priceId,
        newVal,
        cart[priceId].pricePer,
        cart[priceId].description
      );

      sc01.saveCart();
      setCart(sc01.getDict());
    }
  }

  const cartItemRows = [];
  let cartTotalPrice = 0.0;
  Object.keys(sc.getDict()).forEach((priceId) => {
    const elem = cart[priceId];
    const itemPriceTotal = elem.quantity * elem.pricePer;
    const itemPriceFixed2 = itemPriceTotal.toFixed(2);
    cartTotalPrice += itemPriceTotal;
    cartItemRows.push(
      <Row className="d-flex border-bottom mt-3 pb-3" key={priceId}>
        <Col className="text-left align-self-center" xs={6} md={7}>
          <span>{elem.description}</span>
          <br />
          <small className="text-primary">
            {/* eslint-disable */}
            <a
              href="#"
              onClick={(ev) => {
                ev.preventDefault();
                removeItem(priceId);
              }}
            >
              Remove
            </a>
            {/* eslint-enable */}
          </small>
        </Col>
        <Col className="text-right align-self-center" xs={3} md={2}>
          <input
            className="form-control input-sm text-right"
            type="text"
            defaultValue={elem.quantity}
            onChange={(evt) => onQuantityChange(evt, priceId)}
          />
        </Col>
        <Col className="text-right align-self-center" xs={3}>
          {itemPriceFixed2}
        </Col>
      </Row>
    );
  });
  cartTotalPrice = cartTotalPrice.toFixed(2);

  return (
    <div>
      <Card>
        <Card.Header>
          <h1 className="text-primary">Shopping Cart</h1>
        </Card.Header>
        <Card.Body className="text-dark">
          <Row>
            <Col xs={6} md={7}>
              &nbsp;
            </Col>
            <Col xs={3} md={2} className="text-right">
              QUANTITY
            </Col>
            <Col xs={3} className="text-right">
              PRICE
            </Col>

            <Col className="border-bottom border-dark">&nbsp;</Col>
          </Row>

          {cartItemRows}

          <Row className="text-right pt-5">
            <Col xs={9}>
              <span className="lead">SUBTOTAL</span>
            </Col>
            <Col xs={3}>
              <span id="subtotal_span" className="lead">
                {`$${cartTotalPrice}`}
              </span>
            </Col>

            <Col xs={12} className="text-right pt-2">
              <small className="text-black-50">
                All orders ship within 1 week unless otherwise specified
              </small>
              <br />
              <small className="text-black-50">
                Shipping and taxes will be calculated at checkout. Apply promo
                codes at checkout.
              </small>
              <br />
              <small className="text-black-50">
                <span className="text-primary">Free shipping</span>
                &nbsp;within the USA on all orders over $100.
              </small>
            </Col>
          </Row>

          <Row className="text-right pt-2">
            <Col
              xs={12}
              md={{ span: 6, offset: 6 }}
              lg={{ span: 5, offset: 7 }}
              className="mt-2"
            >
              <Button
                variant="primary"
                size="lg"
                onClick={handleCheckoutClick}
                block
              >
                CHECKOUT
              </Button>
              <div className="pt-2 text-center">
                {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
                <a
                  href="#"
                  onClick={() => {
                    window.mixpanel.track('button', {
                      name: 'international_checkout',
                      action: 'click',
                    });
                    setShowInternationalCheckoutModal(true);
                  }}
                >
                  International Non-USA Checkout
                </a>
              </div>
            </Col>
          </Row>
        </Card.Body>
      </Card>

      <Modal
        show={showInternationalCheckoutModal}
        onHide={() => {
          setShowInternationalCheckoutModal(false);
        }}
      >
        <Modal.Header closeButton>
          <h5 className="modal-title">International Hadabot Customers</h5>
        </Modal.Header>
        <Modal.Body>
          <p>
            We&apos;re working hard to launch a checkout form for international
            orders.
          </p>
          <p>
            In the meantime, please email&nbsp;
            <a href="mailto:hi@hadabot.com">hi@hadabot.com</a>
            &nbsp;if you are interested in purchasing a Hadabot kit.
          </p>
          <p>We&apos;ll reply back immediately with a Paypal form.</p>
          <p>
            Thanks!
            <br />
            Jack &quot;Hadabot Maker&quot;
          </p>
        </Modal.Body>
        <Modal.Footer>
          <Button
            variant="primary"
            onClick={() => {
              setShowInternationalCheckoutModal(false);
            }}
          >
            Got It!
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
}

export default Cart;
